import * as types from "../action/actionTypes";

const initialState = {
  selectedLink: "",
  selectedPriority: [],
  priorityOptions: []
};

export default function globalReducer(state = initialState, action: any) {
  switch (action.type) {
    case types.SET_SELECTED_LINK:
      return {
        ...state,
        selectedLink: action.payload
      };
    case types.SET_SELECTED_PRIORITY:
      return {
        ...state,
        selectedPriority: action.payload
      };
    case types.SET_PRIORITY_OPTIONS:
      return {
        ...state,
        priorityOptions: action.payload
      };
    case types.SET_TREATMENT_OPTIONS:
      return {
        ...state,
        treatmentOptions: action.payload
      };
    case types.SET_STRUCTURE_OPTIONS:
      return {
        ...state,
        structureOptions: action.payload
      };
    default:
      return state;
  }
}